(function () {
  "use strict";



  function readGiftConfig() {
    var el = document.getElementById("jt-gift-config");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error("[FreeGift] Invalid #jt-gift-config JSON:", e);
      return null;
    }
  }

  var CONFIG = readGiftConfig();

  if (!CONFIG || CONFIG.enabled === false || !CONFIG.tiers || !CONFIG.tiers.length) {
    console.log("[FreeGift] Disabled or no tiers configured -- skipping.");
    return;
  }

 
  var GIFT_TIERS = CONFIG.tiers.map(function (t) {
    return {
      minTotal: Number(t.minTotal) || 0, // EUR cents
      handle: t.handle || null,
      variantId: t.variantId != null ? Number(t.variantId) : null,
      qty: Number(t.qty) || 0,
      discountCode: t.discountCode || null,
      kind: t.toastKey || "shipping",
      enabled: t.enabled !== false,
      toast: "",
      icon: t.icon || "",
      amountLabel: t.amountLabel || ""
    };
  });

  function giftBadgeText() {
    var el = document.getElementById("jt-reward-toasts");
    return el && el.dataset.giftBadge ? el.dataset.giftBadge : "\u{1F381} GRATIS CADEAU";
  }

  function getLocaleRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    var m = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i);
    return m ? "/" + m[1].toLowerCase() + "/" : "/";
  }

  
  function loadToastStrings() {
    var el = document.getElementById("jt-reward-toasts");
    if (!el) return;
    var byKind = {
      xtool: el.dataset.toastXtool,
      keychain: el.dataset.toastKeychain,
      stickers: el.dataset.toastStickers,
      shipping: el.dataset.toastShipping
    };
    GIFT_TIERS.forEach(function (tier) {
      if (byKind[tier.kind]) tier.toast = byKind[tier.kind];
    });
  }

  var variantCache = {};
  var isSyncing = false;
  var syncQueued = false;

  var SHOWN_TOASTS_KEY = "fg_shown_toasts";
  function loadShownToasts() {
    try { var raw = sessionStorage.getItem(SHOWN_TOASTS_KEY); return new Set(raw ? JSON.parse(raw) : []); }
    catch (e) { return new Set(); }
  }
  function saveShownToasts(s) {
    try { sessionStorage.setItem(SHOWN_TOASTS_KEY, JSON.stringify(Array.from(s))); } catch (e) {}
  }
  var shownToasts = loadShownToasts();

  var DISMISSED_GIFTS_KEY = "fg_dismissed_gifts";
  function loadDismissedGifts() {
    try { var raw = sessionStorage.getItem(DISMISSED_GIFTS_KEY); return new Set(raw ? JSON.parse(raw) : []); }
    catch (e) { return new Set(); }
  }
  function saveDismissedGifts(s) {
    try { sessionStorage.setItem(DISMISSED_GIFTS_KEY, JSON.stringify(Array.from(s))); } catch (e) {}
  }
  var dismissedGifts = loadDismissedGifts();

  function giftHandleForLineEl(item) {
    var link = item.querySelector(".mini-cart__product-title");
    var href = (link && link.getAttribute("href")) || "";
    var tier = GIFT_TIERS.find(function (t) { return t.handle && href.indexOf(t.handle) !== -1; });
    return tier ? tier.handle : null;
  }

  var lastBar = null;

  function injectToastStyles() {
    if (document.getElementById("fg-toast-styles")) return;
    var style = document.createElement("style");
    style.id = "fg-toast-styles";
    style.textContent = [
      "#fg-toast {",
      "  position: fixed;",
      "  top: calc(env(safe-area-inset-top, 0px) + 16px);",
      "  left: 50%;",
      "  z-index: 99999;",
      "  display: flex;",
      "  align-items: center;",
      "  gap: 10px;",
      "  background: #1a1a1a;",
      "  color: #fff;",
      "  padding: 12px 16px;",
      "  border-radius: 12px;",
      "  font-size: 14px;",
      "  font-weight: 600;",
      "  box-shadow: 0 8px 30px rgba(0,0,0,0.25);",
      "  transform: translate(-50%, -20px);",
      "  opacity: 0;",
      "  transition: transform 0.4s cubic-bezier(0.34,1.56,0.64,1), opacity 0.3s ease;",
      "  width: max-content;",
      "  max-width: calc(100vw - 32px);",
      "  white-space: nowrap;",
      "  box-sizing: border-box;",
      "  pointer-events: none;",
      "}",
      "#fg-toast.fg-toast--visible {",
      "  transform: translate(-50%, 0);",
      "  opacity: 1;",
      "  pointer-events: auto;",
      "}",
      "#fg-toast-close {",
      "  background: none;",
      "  border: none;",
      "  color: #aaa;",
      "  font-size: 18px;",
      "  cursor: pointer;",
      "  line-height: 1;",
      "  padding: 0;",
      "  margin-left: 4px;",
      "  flex-shrink: 0;",
      "}",
      "#fg-toast-close:hover { color: #fff; }",
      "@media (max-width: 480px) {",
      "  #fg-toast { padding: 12px; gap: 8px; font-size: 12px; }",
      "}"
    ].join("\n");
    document.head.appendChild(style);
  }

  var toastTimer = null;

  function showToast(message) {
    injectToastStyles();
    var toast = document.getElementById("fg-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "fg-toast";
      toast.innerHTML = '<span id="fg-toast-msg"></span><button id="fg-toast-close" aria-label="Sluiten">\u2715</button>';
      document.body.appendChild(toast);
      document.getElementById("fg-toast-close").addEventListener("click", function () { hideToast(); });
    }
    document.getElementById("fg-toast-msg").textContent = String(message || "").replace(/\s+/g, " ").trim();
    toast.classList.remove("fg-toast--visible");
    clearTimeout(toastTimer);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add("fg-toast--visible");
        toastTimer = setTimeout(hideToast, 3000);
      });
    });
  }

  function hideToast() {
    var toast = document.getElementById("fg-toast");
    if (toast) toast.classList.remove("fg-toast--visible");
  }

  async function getCart() {
    return (await fetch("/cart.js", { cache: "no-store" })).json();
  }

  async function getVariantIdByHandle(handle) {
    if (!handle) return null;
    if (variantCache[handle]) return variantCache[handle];
    try {
      var product = await (await fetch("/products/" + handle + ".js", { cache: "no-store" })).json();
      var vid = product.variants[0].id;
      variantCache[handle] = vid;
      return vid;
    } catch (e) {
      console.error("[FreeGift] Could not load product: " + handle, e);
      return null;
    }
  }

  async function addGiftToCart(variantId, qty) {
    var response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty, properties: { _gift: "true" } })
    });
    if (!response.ok) throw new Error("[FreeGift] Gift could not be added: " + response.status);
  }

  async function changeCartItem(variantId, qty) {
    var cart = await getCart();
    var lineIndex = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) { lineIndex = i + 1; break; }
    }
    if (lineIndex !== null) {
      var res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: lineIndex, quantity: qty })
      });
      if (res.ok) return;
    }
    var updates = {};
    updates[variantId] = qty;
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    });
  }

  async function applyDiscount(code) {
    document.cookie = "discount_code=" + encodeURIComponent(code) + ";path=/;SameSite=Lax";
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { _active_gift_discount: code } })
    });
  }

  async function clearDiscount() {
    document.cookie = "discount_code=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { _active_gift_discount: "" } })
    });
  }

  function refreshMiniCart() {
    var sectionIds = ["header", "main-header", "header-group", "site-header"];
    var tried = 0;
    fetch("/cart.js", { cache: "no-store" })
      .then(function (res) { return res.json(); })
      .then(function (cartData) {
        document.querySelectorAll(".header__cart-count, [data-cart-count]").forEach(function (el) {
          el.textContent = cartData.item_count;
        });
      });
    function tryNext() {
      if (tried >= sectionIds.length) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { scrollToTop: false } }));
        return;
      }
      var sectionId = sectionIds[tried++];
      fetch(getLocaleRoot() + "?section_id=" + sectionId, { cache: "no-store" })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newCart = doc.querySelector("#mini-cart");
          var oldCart = document.querySelector("#mini-cart");
          if (newCart && oldCart) {
            var wasOpen = oldCart.getAttribute("aria-hidden") === "false";
            oldCart.innerHTML = newCart.innerHTML;
            if (wasOpen) oldCart.setAttribute("aria-hidden", "false");
            injectGiftBadge();
            renderRewardBar();
            console.log("[FreeGift] Cart refreshed via section: " + sectionId);
          } else {
            tryNext();
          }
        })
        .catch(tryNext);
    }
    tryNext();
  }

  function injectGiftBadge() {
    document.querySelectorAll(".mini-cart__line-item").forEach(function (item) {
      if (item.querySelector(".free-gift-badge")) return;
      var link = item.querySelector(".mini-cart__product-title");
      var href = (link && link.getAttribute("href")) || "";
      if (GIFT_TIERS.some(function (t) { return t.handle && href.includes(t.handle); })) {
        var badge = document.createElement("div");
        badge.className = "free-gift-badge";
        badge.textContent = giftBadgeText();
        badge.style.cssText = "display:inline-block;background:#e8f5e9;color:#2e7d32;border:1px solid #a5d6a7;border-radius:4px;padding:2px 10px;font-size:11px;font-weight:700;letter-spacing:0.5px;margin-top:5px;text-transform:uppercase;";
        if (link) link.insertAdjacentElement("afterend", badge);
      }
    });
  }

  /* ---------------------------------------------------------------------
     FX RATE CACHE
     Exchange rates don't change meaningfully within a single browsing
     session, so we cache them for a while.
  --------------------------------------------------------------------- */
  var FX_CACHE_KEY_PREFIX = "fg_fx_rate_";
  var FX_CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours

  function getCachedRate(currency) {
    try {
      var raw = sessionStorage.getItem(FX_CACHE_KEY_PREFIX + currency);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Number.isFinite(parsed.rate) || parsed.rate <= 0 || typeof parsed.ts !== "number") return null;
      if (Date.now() - parsed.ts > FX_CACHE_TTL_MS) return null;
      return parsed.rate;
    } catch (e) { return null; }
  }
  function setCachedRate(currency, rate) {
    try { sessionStorage.setItem(FX_CACHE_KEY_PREFIX + currency, JSON.stringify({ rate: rate, ts: Date.now() })); } catch (e) {}
  }

  async function fetchExchangeRate(targetCurrency) {
    if (targetCurrency === "EUR") return 1;
    // Thresholds are configured in EUR, the shop's base currency.
    // Prefer the active Shopify rate so the bar follows the storefront.
    var shopCurrency = window.Shopify && window.Shopify.currency;
    var shopRate = shopCurrency ? Number(shopCurrency.rate) : NaN;
    if (shopCurrency && shopCurrency.active === targetCurrency &&
        Number.isFinite(shopRate) && shopRate > 0) {
      return shopRate;
    }
    var cached = getCachedRate(targetCurrency);
    if (cached !== null) {
      console.log("[FreeGift] Using cached exchange rate EUR -> " + targetCurrency + ": " + cached);
      return cached;
    }
    try {
      var res = await fetch("https://open.er-api.com/v6/latest/EUR", { cache: "no-store" });
      if (!res.ok) throw new Error("FX API returned status " + res.status);
      var data = await res.json();
      var rate = data && data.rates ? data.rates[targetCurrency] : null;
      if (!Number.isFinite(rate) || rate <= 0) throw new Error("No rate found for " + targetCurrency);
      console.log("[FreeGift] Exchange rate EUR -> " + targetCurrency + ": " + rate);
      setCachedRate(targetCurrency, rate);
      return rate;
    } catch (e) {
      console.warn("[FreeGift] Could not fetch exchange rate for " + targetCurrency + ":", e);
      return null;
    }
  }

  function fgFormatMoney(amountMajor, currency, compact) {
    try {
      var locale = document.documentElement.getAttribute("lang") || "nl";
      var formatOptions = { style: "currency", currency: currency };
      if (compact) {
        formatOptions.minimumFractionDigits = 0;
        formatOptions.currencyDisplay = "narrowSymbol";
      }
      return new Intl.NumberFormat(locale, formatOptions).format(amountMajor);
    } catch (e) {
      return (Math.round(amountMajor * 100) / 100) + " " + currency;
    }
  }


  function renderRewardBar(force) {
    if (!lastBar) return;
    var bar = document.querySelector(".reward-bar");
    if (!bar) return;

    var enabledTiers = GIFT_TIERS.filter(function (t) { return t.enabled; });
    var N = enabledTiers.length;
    if (N === 0) { bar.style.display = "none"; return; }

    var subtotal = lastBar.subtotal, rate = lastBar.rate, currency = lastBar.currency;
    var sig = currency + "|" + Math.round(subtotal * 100) + "|" + rate + "|" + N;
    var fill = bar.querySelector(".reward-bar__fill");
    // Cart refreshes can replace the contents while keeping the outer bar.
    // Cache on the actual fill node so new markup is always repainted.
    if (!force && fill && fill.getAttribute("data-fg-sig") === sig) return;
    if (fill) fill.setAttribute("data-fg-sig", sig);

    var el = document.getElementById("jt-reward-toasts");
    var ds = el ? el.dataset : {};

    var th = enabledTiers.map(function (t) { return t.minTotal / 100 * rate; }); // thresholds in presentment currency
    var reached = th.map(function (x) { return subtotal >= x; });
    var reachedCount = 0;
    for (var r = 0; r < reached.length; r++) { if (reached[r]) reachedCount++; }

    // Milestones (Liquid renders them in the same enabled order).
    var milestones = bar.querySelectorAll(".reward-bar__milestone");
    for (var i = 0; i < milestones.length && i < reached.length; i++) {
      var dot = milestones[i].querySelector(".reward-bar__dot");
      if (reached[i]) { milestones[i].classList.add("is-reached"); if (dot) dot.textContent = "\u2713"; }
      else { milestones[i].classList.remove("is-reached"); if (dot) dot.textContent = ""; }
      var amountEl = milestones[i].querySelector(".rb-amount");
      if (amountEl) {
        var tierAmount = fgFormatMoney(th[i], currency, true);
        amountEl.textContent = ds.amountFreeFrom
          ? ds.amountFreeFrom.replace(/\[\[amount\]\]/g, tierAmount)
          : tierAmount;
      }
    }

    // Progress fill (segmented, generalised to N tiers).
    var progress;
    if (reachedCount >= N) {
      progress = 100;
    } else {
      var k = reachedCount;              // first unreached tier
      var prevPos = k * 100 / N;         // position of the previous milestone (0 when k === 0)
      var targetPos = (k + 1) * 100 / N; // position of tier k
      var prevT = k === 0 ? 0 : th[k - 1];
      var denom = th[k] - prevT;
      var frac = denom > 0 ? (subtotal - prevT) / denom : 0;
      if (frac < 0) frac = 0; if (frac > 1) frac = 1;
      progress = prevPos + frac * (targetPos - prevPos);
    }
    if (progress < 0) progress = 0; if (progress > 100) progress = 100;
    if (fill) {
      fill.style.removeProperty("width");
      fill.style.transform = "scaleX(" + (progress / 100) + ")";
    }
    var track = bar.querySelector(".reward-bar__track");
    if (track) track.setAttribute("aria-valuenow", String(Math.round(progress)));

    // Message.
    var msg = "";
    if (reachedCount >= N) {
      msg = ds.msgAll || "";
    } else {
      var msgKeyByKind = { shipping: "msgShipping", stickers: "msgStickers", keychain: "msgKeychain", xtool: "msgXtool" };
      var tmpl = ds[msgKeyByKind[enabledTiers[reachedCount].kind]] || "";
      var remaining = th[reachedCount] - subtotal;
      if (remaining < 0) remaining = 0;
      msg = tmpl.replace(/\[\[amount\]\]/g, fgFormatMoney(remaining, currency));
    }
    var msgEl = bar.querySelector(".reward-bar__msg");
    if (msgEl && msg) msgEl.textContent = msg;

    if (track && msg) track.setAttribute("aria-label", msg);
    bar.classList.toggle("is-complete", reachedCount >= N);
    bar.hidden = false; // Reveal non-EUR amounts only after conversion.
  }

  async function syncGifts() {
    loadToastStrings();
    if (window.theme && window.theme.dealerCustomer) { console.log("[FreeGift] Skipped: dealer customer"); return; }
    if (isSyncing) { syncQueued = true; return; }
    isSyncing = true;
    try {
      var cart = await getCart();
      var cartCurrency = cart.currency || "EUR";

      var exchangeRate = await fetchExchangeRate(cartCurrency);

      // If we couldn't get a real rate for a non-EUR currency, do NOT fall back
      // to 1 (that would unlock every tier incorrectly). Abort and retry later.
      if (exchangeRate === null) {
        console.warn("[FreeGift] Aborting gift sync -- no reliable exchange rate for " + cartCurrency);
        return;
      }

      var toCustomerCurrency = function (eurCents) { return (eurCents / 100) * exchangeRate; };

      var subtotal = 0;
      cart.items.forEach(function (item) {
        if (!(item.properties && item.properties._gift === "true")) {
          subtotal += parseFloat(item.price) * item.quantity / 100;
        }
      });
      console.log("[FreeGift] Subtotal (excl. gifts, " + cartCurrency + "): " + subtotal.toFixed(2));
      lastBar = { subtotal: subtotal, rate: exchangeRate, currency: cartCurrency };
      renderRewardBar();

      // Resolve variant IDs for ALL tiers with a handle (so a tier that was just
      // disabled can still be cleaned out of the cart). Prefer the config's ID.
      var variantIds = {};
      for (var i = 0; i < GIFT_TIERS.length; i++) {
        var tier = GIFT_TIERS[i];
        if (!tier.handle) continue;
        var vid = tier.variantId || (await getVariantIdByHandle(tier.handle));
        if (vid) { variantIds[tier.handle] = vid; variantCache[tier.handle] = vid; }
      }

      var cartMap = {};
      cart.items.forEach(function (item) { cartMap[item.variant_id] = item; });

      // A tier is active only if it is ENABLED and the threshold is met.
      var activeTiers = [];
      for (var j = 0; j < GIFT_TIERS.length; j++) {
        if (GIFT_TIERS[j].enabled && subtotal >= toCustomerCurrency(GIFT_TIERS[j].minTotal)) {
          activeTiers.push(GIFT_TIERS[j]);
        }
      }

      // If the cart drops below a tier, forget its dismissal so re-crossing re-adds the gift.
      for (var d = 0; d < GIFT_TIERS.length; d++) {
        var dt = GIFT_TIERS[d];
        if (dt.handle && subtotal < toCustomerCurrency(dt.minTotal)) {
          dismissedGifts.delete(dt.handle);
          shownToasts.delete("gift_" + dt.handle);
        }
      }
      saveDismissedGifts(dismissedGifts);
      saveShownToasts(shownToasts);

      // Keep gift quantities locked to configured qty.
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._gift === "true") {
          var t = GIFT_TIERS.find(function (t) { return variantCache[t.handle] === item.variant_id; });
          if (t && item.quantity !== t.qty) {
            console.log("[FreeGift] Resetting gift qty back to", t.qty);
            changeCartItem(item.variant_id, t.qty);
          }
        }
      });
      console.log("[FreeGift] Active tiers:", activeTiers.map(function (t) { return t.discountCode; }));

      var cartChanged = false;

      // Remove any gift whose tier is not active (covers both "below threshold"
      // and "toggled off").
      for (var rmi = 0; rmi < GIFT_TIERS.length; rmi++) {
        var rt = GIFT_TIERS[rmi];
        if (!rt.handle) continue;
        var rvid = variantIds[rt.handle];
        if (!rvid) continue;
        var stillActive = activeTiers.some(function (t) { return t.handle === rt.handle; });
        if (!stillActive && cartMap[rvid]) {
          console.log("[FreeGift] Removing:", rt.handle);
          await changeCartItem(rvid, 0);
          cartChanged = true;
        }
      }

      // Add / fix active gift tiers; track the highest active tier that has a code.
      var highestActiveTier = null;
      for (var b = 0; b < activeTiers.length; b++) {
        var bt = activeTiers[b];
        var bvid = bt.handle ? variantIds[bt.handle] : null;
        var inCart = bvid ? cartMap[bvid] : null;
        if (bvid && !inCart && !dismissedGifts.has(bt.handle)) {
          console.log("[FreeGift] Adding:", bt.handle, "x" + bt.qty);
          await addGiftToCart(bvid, bt.qty);
          cartChanged = true;
          var giftToastKey = "gift_" + bt.handle;
          if (!shownToasts.has(giftToastKey)) {
            showToast(bt.toast);
            shownToasts.add(giftToastKey);
            saveShownToasts(shownToasts);
          }
        } else if (bvid && inCart && inCart.quantity !== bt.qty) {
          console.log("[FreeGift] Fixing qty to", bt.qty);
          await changeCartItem(bvid, bt.qty);
          cartChanged = true;
        }
        if (bt.discountCode && (!highestActiveTier || bt.minTotal > highestActiveTier.minTotal)) {
          highestActiveTier = bt;
        }
      }

      if (highestActiveTier) {
        await applyDiscount(highestActiveTier.discountCode);
      } else if (cart.attributes && cart.attributes._active_gift_discount) {
        await clearDiscount();
        cartChanged = true;
      }

      if (cartChanged) refreshMiniCart(); else setTimeout(injectGiftBadge, 150);
    } catch (err) {
      console.error("[FreeGift] Error:", err);
    } finally {
      isSyncing = false;
      if (syncQueued) { syncQueued = false; setTimeout(syncGifts, 350); }
    }
  }

  var _fetch = window.fetch;
  window.fetch = async function () {
    var args = Array.prototype.slice.call(arguments);
    var res = await _fetch.apply(window, args);
    var url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url ? args[0].url : "");
    if ((url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update")) && !url.includes("_active_gift_discount")) {
      setTimeout(syncGifts, 400);
    }
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._url = url || ""; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var url = this._url || "";
    if ((url.includes("/cart/change") || url.includes("/cart/add") || url.includes("/cart/update")) && !url.includes("_active_gift_discount")) {
      this.addEventListener("load", function () { setTimeout(syncGifts, 400); });
    }
    return _send.apply(this, arguments);
  };

  // When a shopper removes a gift by hand, remember it so we don't immediately re-add it.
  document.addEventListener("click", function (e) {
    var rm = e.target.closest(".mini-cart__quantity-remove");
    if (!rm) return;
    var item = rm.closest(".mini-cart__line-item");
    if (!item) return;
    var h = giftHandleForLineEl(item);
    if (h) { dismissedGifts.add(h); saveDismissedGifts(dismissedGifts); }
  }, true);

  document.addEventListener("click", function (e) {
    if (e.target.closest('[data-action="decrease-quantity"], [data-action="increase-quantity"], a[data-action="decrease-quantity"]')) {
      setTimeout(syncGifts, 600);
    }
  }, true);

  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("quantity-selector__value")) setTimeout(syncGifts, 600);
  }, true);

  new MutationObserver(function () { injectGiftBadge(); renderRewardBar(); }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener("DOMContentLoaded", function () { loadToastStrings(); syncGifts(); });
  // Back/forward-cache restores do not fire DOMContentLoaded again.
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      renderRewardBar(true);
      syncGifts();
    }
  });
  document.addEventListener("cart:refresh", function () { setTimeout(syncGifts, 400); });
  document.addEventListener("cart:item-added", function () { setTimeout(syncGifts, 400); });
  document.addEventListener("cart:item-removed", function () { setTimeout(syncGifts, 400); });
  document.addEventListener("cart:quantity-updated", function () { setTimeout(syncGifts, 400); });
})();

/* jt-logo-home-inline */
(function () {
  function homePath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.routes && window.routes.rootUrl) || '/';
    if (!root || root === '/') return '/';
    return String(root).replace(/\/$/, '') + '/';
  }
  function fix() {
    var home = homePath();
    var p = home === '/' ? '' : home.replace(/\/$/, '');
    document.querySelectorAll('a.header__logo-link').forEach(function (a) {
      a.setAttribute('href', home);
    });
    if (!p) return;
    var doubled = p + p;
    document.querySelectorAll('a[href]').forEach(function (a) {
      try {
        var url = new URL(a.getAttribute('href') || '', location.origin);
        if (url.origin !== location.origin) return;
        if (url.pathname === doubled || url.pathname.indexOf(doubled + '/') === 0) {
          a.setAttribute('href', p + (url.pathname.slice(doubled.length) || '/') + url.search + url.hash);
        }
      } catch (e) {}
    });
  }
  function boot() {
    fix();
    [0, 200, 1000, 3000].forEach(function (ms) { setTimeout(fix, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


function initTrustpilot(scope) {
  var root = scope || document;
  var el = root.querySelector('.trustpilot-widget');
  if (!el) return;
  if (window.Trustpilot) {
    window.Trustpilot.loadFromElement(el, true);
  } else {
    setTimeout(function () { initTrustpilot(scope); }, 300);
  }
}





